export const customContent = {
  BIDDING_FILTER: 1,
  BIDDING_CAMPAIGN_COLUMN: 2,
  BIDDING_AD_COLUMN: 3,
  BIDDING_CREATIVE_COLUMN: 4,
  BIDDING_CUSMTOM_COLUMN: 5,
  BIDDING_STATISTIC_USER_CONFIG: 6,

  BRAND_FILTER: 11,
  BRAND_COLUMN: 12,

  LIBRARY_VIDEO_COLUMN: 7,
  LIBRARY_IMAGE_COLUMN: 8,
  LIBRARY_PLAYABLE_COLUMN: 13,
  LIBRARY_VIDEO_FILTER: 9,
  LIBRARY_IMAGE_FILTER: 10,
  LIBRARY_PLAYABLE_FILTER: 14,
};
